<template>
  <vue100vh style="position: fixed; width: 100%;">
<div>
  <v-toolbar style="background: white !important;">
    <v-btn icon @click="toPage('/mobile/homepage')">
      <v-icon>chevron_left</v-icon>
    </v-btn>
    <v-toolbar-title class="CSChatThai">{{$t('Settings.feedback.suggestion')}}</v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
  <v-card-text style="overflow-y: scroll; height: calc(100vh - 127px);">
    <v-layout column justify-center>
      <!-- <div>
          <p style="font-size: 14px;color: black;" class="CSChatThai"><b>เราดีใจที่ได้ยินว่าคุณคิดอย่างไรกับเรา ความคิดเห็นจากคุณจะช่วยปรับปรุงประสบการณ์การใช้งาน One Chat ได้ดียิ่งขึ้น</b></p>
        </div> -->
      <v-icon color="black" style="font-size: 60px !important;">feedback</v-icon>
      <br />
      <div>
        <p style="font-size: 14px;color: black;" class="CSChatThai">&emsp;&emsp;{{$t('Settings.feedback.titleFeedback')}} <a href="mailto:onechat@one.th">onechat@one.th</a> {{$t('Conjunction.or')}}
          <span style="text-decoration: underline; color: #1e88e5; cursor: pointer;" href="javascript:;" @click.stop="conditions = true">{{$t('Settings.feedback.contact')}}</span></p>
        <v-dialog v-model="conditions" width="70%">
          <v-card>
            <v-card-title class="title">{{$t('Settings.feedback.contact')}}</v-card-title>
            <v-card-text v-html="content">
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="blue" @click="conditions = false">{{$t('AnswerQuestion.ok')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <br />
      <v-text-field :placeholder="$t('Settings.feedback.name')" v-model="name" single-line solo></v-text-field>
      <!-- <v-text-field
          label="อีเมล์"
          v-model="email"
          :rules="emailRules"
          single-line
          solo
          required
          disabled
          ></v-text-field>
        <v-text-field
          label="หมายเลขโทรศัพท์"
          v-model="phone"
          mask="###-###-####"
          :rules="phoneRules"
          required
          single-line
          solo
          disabled
        ></v-text-field> -->
      <div class="InputEdit" style="width: 100%;">
        <v-menu bottom offset-y style="width: 100%; height: 20px; margin-bottom: 7px;">
          <v-btn flat slot="activator" row wrap style="width: 100%;padding: 0;margin: 0;">
            <p class="CSChatThai" style="padding-left: 0vw; font: 14px;color: #757575;" v-if="!title.category_TH">{{$t('Settings.feedback.title')}}</p>
            <p class="CSChatThai" style="padding-left: 0vw; font: 14px;color: black;" else>{{($i18n.locale == 'th')? title.category_TH:title.category_ENG }}</p>
            <v-spacer></v-spacer>
            <v-icon style="font-size: 25px !important; color: #929292;">expand_more</v-icon>
          </v-btn>
          <div style="background: white;height: 300px;">
            <div style="background-color: #2562af; color: white; font-size: 16px; font-weight: 700;">
              <span style="padding: 5px !important;" class="CSChatThai">{{$t('Settings.feedback.report')}}</span>
            </div>
            <v-list>
              <v-list-tile v-for="(item, index) in items.list_report" @click="title = item;" style="background: white;">
                <v-list-tile-title class="CSChatThai">{{($i18n.locale == 'th')? item.category_TH:item.category_ENG }}</v-list-tile-title>
              </v-list-tile>
            </v-list>

            <div style="background: white;">
              <div style="background-color: #2562af; color: white; font-size: 16px; font-weight: 700;">
                <span style="padding: 5px !important;" class="CSChatThai">{{$t('Settings.feedback.suggestion')}}</span>
              </div>
              <v-list>
                <v-list-tile v-for="(item, index) in items.list_feedback" @click="title = item;" style="background: white;">
                  <v-list-tile-title class="CSChatThai">{{($i18n.locale == 'th')? item.category_TH:item.category_ENG }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </div>
          </div>
        </v-menu>
      </div>
      <br />
      <v-textarea
        v-model="detail"
        :placeholder="$t('Settings.feedback.detail')"
        counter
        maxlength="255"
        full-width
        single-line
        solo
        height="85"
        style="height: 90px !important;"
      ></v-textarea>
      <!-- <v-textarea v-model="detail" placeholder="รายละเอียด" counter maxlength="255" full-width single-line solo  height="130"></v-textarea> -->
      <br />
      <!-- <form ref="fileformmo" style="float: left;">
        <label>
          <b class="CSChatThai" style="text-decoration: underline;cursor: pointer;text-indent: 5em;">เลือกรูปภาพ</b>
          <input type="file" id="filesmo" ref="filesmo" multiple v-on:change="handleFilesUploadmo()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp" />
        </label>
      </form>
      <v-flex xs12 sm12 md12 v-if="filesmo.length > 0 " style="overflow-x: scroll;overflow-y: hidden;height: 30vh !important; width: 100% !important; display: -webkit-inline-box; background: rgb(234, 234, 234); padding-top: 3px;"
        class="containers hidden-md-and-up">
        <div class="borderfilemo" v-for="(file, key) in filesmo" style="justify-content: center; margin-left: 2vw; padding-top: 1vh;">
          <a style="float: right; padding-right: 10px; font-size: 20px;" class="close-classic" @click="removeFilemo( key )"></a>
          <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center;">
            <img class="preview" v-bind:ref="'preview'+parseInt( key )" style="height: 15vh !important; width:15vh !important;display: flex;justify-content: center;" />
            <b class="text2">{{ file.file.name }}</b>
          </div>
          <div v-else style="text-align: center; display: grid; justify-content: center;">
            <v-icon style="font-size: 60px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
            <b class="text2">{{ file.file.name }}</b>
          </div>
        </div>
      </v-flex> -->
      <form ref="fileformmo" style="float: left; display: none;">
        <label>
          <b class="CSChatThai" style="text-decoration: underline;cursor: pointer;text-indent: 5em;">{{$t('Settings.feedback.selectPicture')}}</b>
          <input type="file" id="filesmo" ref="filesmo" multiple v-on:change="handleFilesUploadmo()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp"/>
        </label>
      </form>
      <h4>{{$t('Settings.feedback.selectPicture')}}</h4>
      <v-layout row wrap class="containers hidden-md-and-up layoutimagemo" align-center>
        <div style="text-align: center; height: 20vh; margin: auto;" v-if="filesmo.length === 0" >
          <label style="text-align: center; cursor: pointer;">
            <v-icon color="primary" style="font-size: 40px !important; color: #1a222c;display: flex;justify-content: center;">mdi-package-variant</v-icon>
            <p style="font-size: 13px;">{{$t('Settings.editProfile.support')}} .JPEG/.PNG/.GIF</p>
            <div>
              <v-btn
                color="primary"
                small 
                outline
                @click="uppicmo()"
              >
                {{$t('AnswerQuestion.uploadPhoto')}}
              </v-btn>
            </div>
          </label>
        </div>
        <v-flex xs12 sm12 md12 style="overflow-y: scroll; height: 195px; display: -webkit-inline-box;  padding-top: 10px; width: 100%" class="containers">
          <div v-for="(file, key) in filesmo" style="justify-content: center; margin-left: 2vw; padding-top: 1vh; align-items: center;">
            <div v-if="extension(file.file.name) == 'fas fa-file-image'" class="previewimgmobile" style="text-align: center; display: grid; justify-content: center;">
              <v-icon style="margin-left: 100px;" color="primary" @click="removeFilemo( key )">close</v-icon>
              <img v-bind:ref="'preview'+parseInt( key )" style="margin-left: 20px; height: 80px !important; width: 80px !important; display: flex;justify-content: center; margin-top: 10px; align-items: center !important; margin-bottom: 10px; object-fit: cover;" />
              <!-- <img class="preview" v-bind:ref="'preview'+parseInt( key )" style="height: 80px !important; width: 80px !important; display: flex;justify-content: center; margin-top: 10px;" /> -->
              <b class="text2" style="margin-left: 25px;">{{ file.file.name }}</b>
            </div>
            <div v-else style="text-align: center; display: grid; justify-content: center;" >
              <v-icon style="font-size: 60px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
              <b class="text2">{{ file.file.name }}</b>
            </div>
          </div>
          <div style="justify-content: center; margin-left: 2vw; padding-top: 1vh; align-items: center; display: flex;" v-if="filesmo.length !== 0 && filesmo.length !== 5">
            <v-btn outline color="primary" @click="uppicmo()" style="height: 70px; border-radius: 10px;">
              <v-icon style="font-size: 40px;">mdi-image-plus</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <br />
      <v-layout align-center row justify-center>
        <v-btn dark color="blue" @click="sendfeedbackmo()" v-if="name !== '' && email !== '' && title.category_TH && detail !== ''">
          <span>{{$t('AnswerQuestion.sendme')}}</span>
        </v-btn>
        <v-btn disabled v-else>
          <span>{{$t('AnswerQuestion.sendme')}}</span>
        </v-btn>
        <v-btn dark color="blue-grey" style="color: white !important;" @click="cancel()">
          <span>{{$t('AnswerQuestion.cancel')}}</span>
        </v-btn>
      </v-layout>
    </v-layout>
  </v-card-text>
</div>
</vue100vh>
</template>
<script type="text/javascript">
import { Decode } from '@/services'
import vue100vh from 'vue-100vh'
var _ = require('lodash')
export default {
  data: () => ({
    autogrow: false,
    filesmo: [],
    detail: '',
    title: {},
    name: '',
    email: '',
    phone: '',
    items: [],
    token: '',
    comment: '',
    status: '',
    conditions: false,
    content: '',
    phoneRules: [
      v => (!!v && v.length === 10) || 'กรุณากรอกตัวเลขให้ครบ 10 หลัก',
      v => !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข',
      v => /^0[0-9]{9}/.test(v) || 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง'
    ],
    emailRules: [
      v => !!v || 'กรุณากรอกอีเมล์',
      v => !v || (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'รูปแบบอีเมล์ไม่ถูกต้อง'
    ]
  }),
  created() {
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.email = localStorage.getItem('email')
    this.name = localStorage.getItem('name')
    this.phone = localStorage.getItem('phone')
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
    this.content = '<b>' + this.$t('Settings.helpCenter.company') + '</b> <br>' + this.$t('Settings.helpCenter.address')+' <br>' + this.$t('Settings.helpCenter.email') + ' <a style="text-decoration: none;" href="mailto:onechat@one.th">onechat@one.th</a>'
    this.getsubject()
  },
  watch: {
    filesmo() {
      if (this.filesmo.length > 5) {
        this.$swal(
          '',
          this.$t('Alert.Fail.feedback.maxFiles'),
          'warning'
        )
        _.pullAt(this.filesmo, [5])
      }
    }
  },
  components: {
    vue100vh
  },
  methods: {
    uppicmo () {
      $('#filesmo').click()
    },
    handleFilesUploadmo(key) {
      let uploadedFiles = this.$refs.filesmo.files
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.filesmo.push({
          file: uploadedFiles[i],
          status: 'waiting'
        })
      }
      this.getImagePreviewsmo(key)
      document.querySelector('#filesmo').value = ''
    },
    getImagePreviewsmo(key) {
      for (let i = 0; i < this.filesmo.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.filesmo[i].file.name)) {
          let reader = new FileReader()
          reader.addEventListener('load', function() {
            this.$refs['preview' + parseInt(i)][0].src = reader.result
          }.bind(this), false)
          reader.readAsDataURL(this.filesmo[i].file)
          // this.extension(this.files[i].name)
          // console.log(this.extension())
        } else {
          // this.$nextTick(function(){
          // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
          // });
          // console.log('mm')
        }
      }
    },
    sendfeedbackmo() {
      var lengthfile = this.filesmo.length
      if (lengthfile === 0) {
        let formData = new FormData()
        formData.append('phone', this.phone)
        formData.append('email', this.email)
        formData.append('comment', this.detail)
        formData.append('name', this.name)
        formData.append('category_id', this.title.category_id)
        this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
          // console.log(response.data)
          this.$swal('', this.$t('Alert.Success.feedback'), 'success')
          this.cancel()
        }, () => {
          this.$swal('', this.$t('Alert.Fail.feedback.connectError'), 'error')
        })
      } else {
        this.sendfeedbackfilemo()
        // for (var i = 0; i < lengthfile; i++) {
        //   this.sendfeedbackfile(i)
        // }
      }
    },
    sendfeedbackfilemo() {
      let formData = new FormData()
      var lengthfile = this.filesmo.length
      for (var i = 0; i < lengthfile; i++) {
        var file = this.filesmo[i].file
        formData.append('file', file, file.name)
      }
      // console.log(formData)
      formData.append('phone', this.phone)
      formData.append('email', this.email)
      formData.append('comment', this.detail)
      formData.append('name', this.name)
      formData.append('category_id', this.title.category_id)
      this.axios.post(process.env.APImanage + '/feedbackcategory', formData).then((response) => {
        // console.log(response.data)
        this.$swal('', this.$t('Alert.Success.feedback'), 'success')
        this.cancel()
      }, () => {
        this.$swal('', this.$t('Alert.Fail.feedback.connectError'), 'error')
      })
    },
    extension(files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var file = ['ai', 'ps', 'psd']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (file.includes(extension)) {
        return 'fas fa-file'
      } else {
        return 'fas fa-file-alt'
      }
      // return extension[extension.length-1]
    },
    cancel() {
      // this.phone = ''
      // this.name = ''
      // this.email = ''
      this.title = {}
      this.detail = ''
      this.filesmo = []
    },
    getsubject() {
      this.axios.post(process.env.APImanage + '/getcategory').then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          this.items = response.data
        }
      })
    },
    toPage(data) {
      this.$router.push(data)
    },
    removeFilemo(key) {
      this.filesmo.splice(key, 1)
      this.getImagePreviewsmo(key)
    },
  }
}
</script>
<style type="text/css" scoped>
.layoutimagemo {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 195px !important;
  max-width: 100% !important;
  display: -webkit-inline-box;
  background: rgb(234, 234, 234);
  padding-top: 3px; background: rgb(255, 255, 255);
  padding-top: 3px;
  border-style: solid;
  border-width: thin;
  border-radius: 10px;
  border-color: #e5e9eb;
}
.previewimgmobile {
  text-align: center;
  display: grid;
  justify-content: center;
  border-style: solid;
  border-width: thin;
  border-radius: 10px;
  width: 140px;
  border-color: #2562af;
  background-color: white;
}
.text2 {
  white-space: nowrap;
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close-classic:after {
  content: '×';
  /* ANSI X letter */
}

.containers {
  width: 576px;
  margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}

.borderfilemo {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 40vw !important;
  height: 25vh !important;
  position: relative;
  background: white;
}

.InputEdit {
  width: 100%;
  padding: 5px 15px;
  background-color: #fff;
  border: 1px solid #d2d8dd;
  border-radius: 4px;
}

>>>.v-text-field.v-text-field--enclosed {
  margin: 0;
  width: 100%;
  padding: 0;
}

/* >>>.v-textarea.v-text-field--full-width.v-text-field--single-line .v-text-field__slot textarea,
.v-textarea.v-text-field--full-width .v-text-field__slot textarea {
  height: 120px;
  margin-top: 0;
  width: 100%;
} */
>>>.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    /* padding-right: 12px; */
    /*font-size: 14px;*/
    font-size: 14px;
    resize: none;
    height: 75px !important;
}
>>>.v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;
  padding: 0;
}

>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: none;
}

>>>.v-input__slot {
  border-width: thin;
  border-style: solid;
  border-color: #d2d8dd;
  border-radius: 10px;
}

>>>.v-toolbar {
  /* box-shadow: none; */
  box-shadow: 0 2px 0px -1px hsla(0,0%,100%,.12), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12) !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.btnsendfeed {
  width: 100%;
  color: white;
  border-radius: 5px;
}

a:link {
  text-decoration: none;
  color: black !important;
}

a:visited {
  color: white !important;
  text-decoration: none;
}

a:hover {
  color: #1e88e5 !important;
  text-decoration: none;
}

a:active {
  color: black !important;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/settings/Feedback.vue